import { render, staticRenderFns } from "./CompensationApproval.vue?vue&type=template&id=4de8a08f"
import script from "./CompensationApproval.vue?vue&type=script&lang=js"
export * from "./CompensationApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports